// Attempts to translate the page into the target language
export const translateText = async (text, targetLang, apiKey) => {
    try {
      if (!text || typeof text !== 'string' || text.trim() === '') {
        return '';
      }

      const res = await fetch(
        `https://translation.googleapis.com/language/translate/v2?key=${apiKey}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            q: text,
            target: targetLang,
            format: 'text',
          }),
        }
      );
  
      const data = await res.json();

      if (data.error) {
        console.error("Google Translate API Error:", data.error);
        return text;
      }

      return data.data.translations[0].translatedText;
    } catch (err) {
      console.error('Translation failed:', err);
      return text;
    }
  };
  